import React from 'react'
import { BrowserRouter as Router, Switch, Redirect, Route } from 'react-router-dom'

import config from './config'
import AuthRedirect from './containers/AuthRedirect'

import App from './containers/App'
import LoginPageInternal from './containers/LoginPageInternal'
import LoginPageExternal from './containers/LoginPageExternal'

import WelcomePageExternal from './containers/WelcomePageExternal'
import WelcomePage from './containers/WelcomePage'
import HomePage from './containers/HomePage'
import AdminHomePage from './containers/AdminHomePage'
import TrackerForm from './containers/TrackerForm'
import CreatePerson from './containers/CreatePerson'
import CreateAgent from './containers/CreateAgent'
import EditForm from './containers/Edit/EditForm'
import ViewForm from './containers/View/ViewForm'
import ViewPersonForm from './containers/ViewPerson/ViewPersonForm'

// import LoginBoth from './components/LoginBoth'

const LoginRedirect = () => <Redirect to='/login' />

// const debug = false;

const createRoutes = (history) => 
  (

  <Router basename={config.BASE_URL}>
    <div>
      <Route path='/' component={App} />
      <Route exact path='/' render={LoginRedirect} />
      <Switch>
        {//unprotected routes/redirects
        }
        <Route path='/carriersignup' component={CreatePerson} /> 
        <Route path='/agentsignup' component={CreateAgent} /> 

        { ('external' === config.LOGIN) && (
        <Route path='/login' component={LoginPageExternal} />     
        ) }

        {('internal' === config.LOGIN) && (
        <Route path='/login' component={WelcomePage} />                
        ) }

        <Route path='/LoginInternal' component={LoginPageInternal} />  
        {//protected routes/redirects
        }
        <Route path='/WelcomeExternal' component={AuthRedirect(WelcomePageExternal)} />
        <Route path='/home' component={AuthRedirect(HomePage)} />     
        <Route path='/tracker' component={AuthRedirect(TrackerForm)} />       
        <Route path='/edit' component={AuthRedirect(EditForm)} />           
        <Route path='/view' component={AuthRedirect(ViewForm)} />    
        <Route path='/adminhome' component={AuthRedirect(AdminHomePage)} />         
        <Route path='/viewperson' component={AuthRedirect(ViewPersonForm)} />     
        {// Guidelines download links redirect to login pages (to avoid improper access vulnerability)
        } 

        {/* <Route path='/dangerous-ws/hazmat/downloadGuide/*' component={WelcomePage} /> */}
        
      </Switch>
    </div>
  </Router>
  )



export default createRoutes